import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector.
   * Cart page: uses absolute max (how much can be in cart total).
   * @returns {number | null} The effective max, or null if no max.
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  /**
   * Updates button states based on current value and limits.
   * Minus button is NEVER disabled — at qty 1 it triggers removal instead.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = false;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }

  /**
   * Override decreaseQuantity:
   * - If quantity is at minimum (1), dispatch quantity 0 to trigger line item removal.
   * - Otherwise decrease normally.
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();

    const { value, min } = this.getCurrentValues();
    const input = this.refs.quantityInput;

    if (value <= min) {
      input.value = '0';
      this.onQuantityChange();
      this.updateButtonStates();
    } else {
      this.updateQuantity(-1);
    }
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
